import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient,HttpHeaders,HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomRuleService {

  constructor(private http: HttpClient) { }

  getAllModules() {
    return this.http.get<any>(`${environment.configUrl}LionO360_Object`)
  }

  getConfigurationsByModuleName(configName){
    return this.http.get<any>( `${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${configName}`)
  }

  getChannelByModuleId(moduleId){
    return this.http.get<any>( `${environment.configUrl}v2/Channel/SelectList/Module/${moduleId}`);
  }

  getGroups(){
    return this.http.get<any>( `${environment.coreUrl}Group`);
  }

  getCustomTypes(groupId){
    return this.http.get<any>( `${environment.coreUrl}Type?groupId=${groupId}`);
  }

  checkCustomRuleCombination(moduleId,channelId,typeId){
    return this.http.get<any>(`${environment.inventoryURl}CustomRules/CheckDuplicateRule?CustomRulesId=0&ModuleId=${moduleId}&ChannelId=${channelId}&TypeId=${typeId}`);
  }

  addCustomRule(data){
    return this.http.post<any>(`${environment.inventoryURl}CustomRules`,data)
    .toPromise()
    .then((res) => res);
  }

  updateCustomRule(data){
    return this.http.put<any>(`${environment.inventoryURl}CustomRules`,data)
    .toPromise()
    .then((res) => res);
  }

  updateBulkPaymentTermVendor(data){
    return this.http.put<any>(`${environment.inventoryURl}Vendor/EditBulkVendorPaymentTerm`,data)
    .toPromise()
    .then((res) => res);
  }

  updateBulkPaymentMethodVendor(data){
    return this.http.put<any>(`${environment.inventoryURl}Vendor/EditBulkVendorPaymentMethod`,data)
    .toPromise()
    .then((res) => res);
  }

  updateBulkPaymentTermAccount(data){
    return this.http.put<any>(`${environment.apiUrlAccount}AccountInventoryCustomRule/EditBulkAccountPaymentTerm`,data)
    .toPromise()
    .then((res) => res);
  }

  updateBulkPaymentMethodAccount(data){
    return this.http.put<any>(`${environment.apiUrlAccount}AccountInventoryCustomRule/EditBulkAccountPaymentMethod`,data)
    .toPromise()
    .then((res) => res);
  }

  getAllCustomRules(){
    return this.http.get<any>(`${environment.inventoryURl}CustomRules`);
  }

  getCustomRuleById(id){
    return this.http.get<any>( `${environment.inventoryURl}CustomRules/${id}`);
  }

  getAllVendors(pageNo,pageSize,searchColumn,searchValue){
    let params = new HttpParams();
    params = params.append('PageNumber', pageNo)
    params = params.append('PageSize', pageSize)
    params = params.append('IsAscending', false)
    params = params.append('SearchColumns', searchColumn)
    params = params.append('isActive', true)
    params = params.append('SearchValue', searchValue)
     return this.http.get<any>(`${environment.inventoryURl}Vendor/AllVendors`,{observe: 'response',params})
         .toPromise()
         .then(res=> ({
             vendors: res.body,
             headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
         }))
  }

  getAllAccounts(pageNo,pageSize,channelId,searchColumn,searchValue){
    let params = new HttpParams();
    params = params.append('PageNumber', pageNo)
    params = params.append('PageSize', pageSize)
    params = params.append('ChannelId', channelId)
    params = params.append('IsAscending', false)
    params = params.append('SortBy', 'createddate')
    params = params.append('SearchColumns', searchColumn)
    params = params.append('IsActive', true)
    params = params.append('SearchValue', searchValue)
     return this.http.get<any>(`${environment.apiUrlAccount}Account/AllAccountDetails`,{observe: 'response',params})
         .toPromise()
         .then(res=> ({
             accounts: res.body,
             headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
         }))
  }

}
